import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSessionStorage } from '@sorare/core/src/hooks/useSessionStorage';
import { withFragments } from '@sorare/core/src/lib/gql';

import type { useSaveBestPackCardPicture_anyCardInterface } from './__generated__/useSaveBestPackCardPicture.graphql';

export const useSaveBestPackCardPicture = withFragments(
  () => {
    const [, setBestPackCardPictureUrl] = useSessionStorage(
      'bestPackCardPictureUrl'
    );

    return (cards: Nullable<useSaveBestPackCardPicture_anyCardInterface[]>) => {
      const bestCard = [...(cards || [])]
        .sort((a, b) => (a.dropRank || 0) - (b.dropRank || 0))
        .at(0);
      if (bestCard?.pictureUrl) {
        setBestPackCardPictureUrl(bestCard?.pictureUrl);
      }
    };
  },
  {
    anyCardInterface: gql`
      fragment useSaveBestPackCardPicture_anyCardInterface on AnyCardInterface {
        slug
        dropRank
        pictureUrl
      }
    ` as TypedDocumentNode<useSaveBestPackCardPicture_anyCardInterface>,
  }
);
